import { useTranslation } from 'next-i18next'

import { TutorStatus } from '~/types/tutoring-api'

const PlaceholderAvatar = 'avatar-portraits/hom-default-avatar.png'
import ResponsiveImage from './Image/ResponsiveImage'

type ImageProps = { imageSrc?: string | null; imageSrcKey?: undefined } | { imageSrc?: undefined; imageSrcKey?: string }

export default function HoMCard({
  bio,
  education,
  imageSrc,
  imageSrcKey,
  name,
  title,
}: {
  status?: TutorStatus
  bio?: string
  education?: string
  name?: string | null
  title?: string
} & ImageProps): React.ReactElement {
  return (
    <div className="w-80 max-w-full h-min px-8 py-14 flex flex-col justify-between rounded shadow-large bg-gray-off-white">
      <div className="space-y-4">
        <HeadShot imageSrc={imageSrc} imageSrcKey={imageSrcKey} name={name} />
        <section>
          <Name name={name} />
          <Title title={title} />
        </section>
      </div>

      <section>
        <Education education={education} />
        <Bio bio={bio} />
      </section>
    </div>
  )
}

const mediaQueryPlaceHolder = [{ screen: '(min-width: 280px)', width: '150px' }]
const mediaQueryAvatar = [{ screen: '(min-width: 280px)', width: '60vw' }]
function HeadShot({
  imageSrc,
  imageSrcKey,
  name,
}: {
  imageSrc?: string | null
  imageSrcKey?: string
  name?: string | null
}): React.ReactElement {
  const imageAlt = name ?? 'Avatar'
  const imageClassName = 'p-2 inset-center object-cover rounded-full'

  return (
    <div className="relative w-40 h-40 mx-auto rounded-full bg-employee-card-outer-border">
      <div className="absolute inset-px rounded-full bg-gray-off-white">
        {imageSrc ? (
          <ResponsiveImage
            alt={imageAlt}
            imageClassName={imageClassName}
            mediaQuery={mediaQueryAvatar}
            src={imageSrc}
          />
        ) : (
          <ResponsiveImage
            alt={imageAlt}
            fit="contain"
            height={150}
            imageClassName={imageClassName}
            imageWidths="150"
            mediaQuery={mediaQueryPlaceHolder}
            srcKey={imageSrcKey || PlaceholderAvatar}
            width={150}
          />
        )}
      </div>
      <div className="absolute inset-0 m-2 border border-white rounded" />
    </div>
  )
}

function Name({ name }: { name?: string | null }): React.ReactElement {
  return <div className="text-center text-lg leading-8 font-semibold text-black-card">{name}</div>
}

function Title({ title }: { title?: string }): React.ReactElement {
  return <div className="my-1 text-center text-purple">{title}</div>
}

function Education({ education }: { education?: string }): React.ReactElement {
  const { t } = useTranslation('ourTeam')

  return (
    <div className="my-4 text-center">
      <div className="text-md font-medium text-gray-placeholder">{t('education')}</div>
      <div className="text-gray-placeholder">{education}</div>
    </div>
  )
}

function Bio({ bio }: { bio?: string }): React.ReactElement {
  return <p className="text-center text-xs text-gray-placeholder">{bio}</p>
}
